import {useAuthStore} from '../store/useAuthStore';

export const usePermission = () => {
  const user = useAuthStore(state => state.user);

  const hasPermission = permission => {
    if (!user) return false;
    if (user.owner || user.isOwner) return true;
    return user.permissions?.includes(permission) || false;
  };

  const hasAnyPermission = permissions => {
    return permissions.some(p => hasPermission(p));
  };

  const hasAllPermissions = permissions => {
    return permissions.every(p => hasPermission(p));
  };

  const isOwner = user?.owner || user?.isOwner || false;

  return {hasPermission, hasAnyPermission, hasAllPermissions, isOwner};
};
